import { useState } from 'react'
import './App.css'
import { FiDelete } from 'react-icons/fi'

const Loading = () => {
  return (
    <div className='loading'>
      <span className='text'>calculate ...</span>
    </div>
  )
}
const is_op = (x) => {
  return x === '*' || x === '-' || x === '/' || x === '+'
}


const App = () => {

  const [result, setResult] = useState("");
  const [equation, setEquation] = useState("");
  const [loader, setLoader] = useState(false);

  const handleClick = async (value) => {
    if (value === "=") {
      setLoader(true)
      try {
        const response = await fetch("https://ghaithx.pythonanywhere.com/evaluate/", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "expression": equation
          })
        });

        const data = await response.json();
        setLoader(false)
        if (data.result) setResult(data.result);
        else setResult(data.error);

      } catch (error) {
        setLoader(false)
        setResult("NetWork Error");
      }

    } else if (value === "AC") {
      setResult("");
      setEquation("");

    } else if (is_op(value)) {
      if (is_op(equation[equation.length - 1])) {
        let copy = equation.slice(0, equation.length - 1)
        setEquation(copy + value)
      }
      else {
        setEquation((prevEquation) => prevEquation + value);
      }

    } else if (value === 'delete') {
      setEquation((prevEquation) => prevEquation.slice(0, prevEquation.length - 1));

    } else {
      setEquation((prevEquation) => prevEquation + value);
    }
  };

  return (
    <div className="container">
      <div className="calculator">
        <input
          type="text"
          className="calculator-display"
          value={equation}
          disabled
        // onChange={(e) => { setEquation(e.target.value) }}
        />
        <div className="calculator-result">{loader ? <Loading /> : result}</div>

        <div className="calculator-buttons">
          <div className="calculator-row">
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("AC")}>AC</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)", "width": "15%" }} onClick={() => handleClick("(")}>(</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)", "width": "15%" }} onClick={() => handleClick(")")}>)</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("/")}>/</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("delete")}><FiDelete /></button>


          </div>
          <div className="calculator-row">
            <button onClick={() => handleClick("7")}>7</button>
            <button onClick={() => handleClick("8")}>8</button>
            <button onClick={() => handleClick("9")}>9</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("*")}>*</button>
          </div>
          <div className="calculator-row">
            <button onClick={() => handleClick("4")}>4</button>
            <button onClick={() => handleClick("5")}>5</button>
            <button onClick={() => handleClick("6")}>6</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("-")}>-</button>
          </div>
          <div className="calculator-row">
            <button onClick={() => handleClick("1")}>1</button>
            <button onClick={() => handleClick("2")}>2</button>
            <button onClick={() => handleClick("3")}>3</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)" }} onClick={() => handleClick("+")}>+</button>
          </div>
          <div className="calculator-row">
            <button onClick={() => handleClick("0")}>0</button>
            <button onClick={() => handleClick(".")}>.</button>
            <button style={{ "backgroundColor": "hsl(35, 100%, 68%)", "color": "hsl(0, 0%, 19%)", "width": "68%" }} onClick={() => handleClick("=")}>=</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App
